import { render, staticRenderFns } from "./WeightBalanceEnvelope.vue?vue&type=template&id=4efcfe22"
import script from "./WeightBalanceEnvelope.vue?vue&type=script&lang=js"
export * from "./WeightBalanceEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports